export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const TERTIARY = 'tertiary';
export const TRANSPARENT = 'transparent';

// Type for AIButton and AILoadingButton